export const initialStoreApprovals = [
  {
    id: "store-approval-101",
    name: "오후의 식탁",
    category: "한식",
    region: "서울",
    address: "서울 성동구 서울숲길 24",
    phone: "02-555-1024",
    email: "owner@afternoontable.example",
    ownerName: "김서연",
    businessNumber: "123-45-67890",
    approvalStatus: "pending",
    verificationStatus: "reviewing",
    mainImageUrl:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=900&q=80",
    description: "제철 식재료를 활용한 한식 반상과 계절 메뉴를 소개합니다.",
    representativeMenus: ["봄나물 솥밥", "주꾸미 미나리전"],
    documents: [
      { id: "doc-101-1", name: "사업자등록증.pdf", type: "business_registration" },
      { id: "doc-101-2", name: "영업신고증.pdf", type: "business_license" },
      { id: "doc-101-3", name: "통장사본.pdf", type: "bank_account" },
    ],
    appliedAt: "2026-06-15T09:42:00+09:00",
    updatedAt: "2026-06-15T09:42:00+09:00",
    reviewReason: "",
  },
  {
    id: "store-approval-102",
    name: "모닝 베이크",
    category: "베이커리",
    region: "경기",
    address: "경기 성남시 분당구 정자일로 15",
    phone: "031-701-2204",
    email: "hello@morningbake.example",
    ownerName: "박지훈",
    businessNumber: "214-81-22331",
    approvalStatus: "pending",
    verificationStatus: "verified",
    mainImageUrl:
      "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=900&q=80",
    description: "매일 아침 직접 굽는 사워도우와 제철 과일 페이스트리를 판매합니다.",
    representativeMenus: ["딸기 데니시", "사워도우"],
    documents: [
      { id: "doc-102-1", name: "사업자등록증.pdf", type: "business_registration" },
      { id: "doc-102-2", name: "영업신고증.pdf", type: "business_license" },
    ],
    appliedAt: "2026-06-14T16:20:00+09:00",
    updatedAt: "2026-06-14T17:02:00+09:00",
    reviewReason: "",
  },
  {
    id: "store-approval-103",
    name: "바다담",
    category: "일식",
    region: "부산",
    address: "부산 수영구 광안해변로 112",
    phone: "051-711-5003",
    email: "contact@badadam.example",
    ownerName: "최민수",
    businessNumber: "617-92-48120",
    approvalStatus: "on_hold",
    verificationStatus: "reviewing",
    mainImageUrl:
      "https://images.unsplash.com/photo-1579871494447-9811cf80d66c?auto=format&fit=crop&w=900&q=80",
    description: "부산 제철 해산물과 숙성회를 중심으로 운영하는 작은 일식당입니다.",
    representativeMenus: ["제철 모둠회", "고등어 봉초밥"],
    documents: [
      { id: "doc-103-1", name: "사업자등록증.pdf", type: "business_registration" },
      { id: "doc-103-2", name: "영업신고증_재발급중.txt", type: "business_license" },
    ],
    appliedAt: "2026-06-13T11:15:00+09:00",
    updatedAt: "2026-06-14T10:05:00+09:00",
    reviewReason: "영업신고증 원본 재제출 대기",
  },
  {
    id: "store-approval-104",
    name: "제주 초록상",
    category: "카페",
    region: "제주",
    address: "제주 제주시 애월읍 녹차로 8",
    phone: "064-799-0821",
    email: "green@jejutable.example",
    ownerName: "고은채",
    businessNumber: "616-34-88720",
    approvalStatus: "approved",
    verificationStatus: "verified",
    mainImageUrl:
      "https://images.unsplash.com/photo-1559925393-8be0ec4767c8?auto=format&fit=crop&w=900&q=80",
    description: "제주 농가 식재료로 음료와 디저트를 만드는 로컬 카페입니다.",
    representativeMenus: ["청귤 에이드", "당근 케이크"],
    documents: [
      { id: "doc-104-1", name: "사업자등록증.pdf", type: "business_registration" },
      { id: "doc-104-2", name: "영업신고증.pdf", type: "business_license" },
    ],
    appliedAt: "2026-06-11T14:10:00+09:00",
    updatedAt: "2026-06-12T09:30:00+09:00",
    reviewReason: "",
  },
  {
    id: "store-approval-105",
    name: "산골 국수",
    category: "한식",
    region: "강원",
    address: "강원 춘천시 소양강로 71",
    phone: "033-255-9011",
    email: "owner@mountainnoodle.example",
    ownerName: "정하늘",
    businessNumber: "221-07-11924",
    approvalStatus: "rejected",
    verificationStatus: "rejected",
    mainImageUrl:
      "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?auto=format&fit=crop&w=900&q=80",
    description: "들기름 막국수와 감자전을 판매하는 강원 지역 식당입니다.",
    representativeMenus: ["들기름 막국수", "감자전"],
    documents: [
      { id: "doc-105-1", name: "사업자등록증.pdf", type: "business_registration" },
    ],
    appliedAt: "2026-06-10T13:24:00+09:00",
    updatedAt: "2026-06-11T15:40:00+09:00",
    reviewReason: "사업자 정보와 신청자 정보가 일치하지 않습니다.",
  },
  {
    id: "store-approval-106",
    name: "소담 분식",
    category: "분식",
    region: "서울",
    address: "서울 마포구 월드컵북로 39",
    phone: "02-322-7080",
    email: "sodam@sodamfood.example",
    ownerName: "이소담",
    businessNumber: "105-28-77102",
    approvalStatus: "pending",
    verificationStatus: "not_requested",
    mainImageUrl:
      "https://images.unsplash.com/photo-1635363638580-c2809d049eee?auto=format&fit=crop&w=900&q=80",
    description: "동네에서 편하게 즐기는 떡볶이와 튀김 전문점입니다.",
    representativeMenus: ["쌀떡볶이", "모둠 튀김"],
    documents: [
      { id: "doc-106-1", name: "사업자등록증.pdf", type: "business_registration" },
    ],
    appliedAt: "2026-06-15T08:18:00+09:00",
    updatedAt: "2026-06-15T08:18:00+09:00",
    reviewReason: "",
  },
];
